import React from 'react';
import { AlignLeft, Calendar, CheckSquare, Inbox, type LucideIcon } from 'lucide-react';
import { HIGHLIGHTERS, Highlighter } from '../../lib/paper';
import { EnterOnce } from '../paper';

interface Starter {
  text: string;
  icon: LucideIcon;
  tone: Highlighter;
  tilt: number;
}

// Same four as mobile (mobile/src/features/workspace/chat-starters.tsx).
const STARTERS: readonly Starter[] = [
  { text: 'What did I write this week?', icon: Calendar, tone: HIGHLIGHTERS.yellow, tilt: -1.5 },
  { text: 'Find all my to-dos', icon: CheckSquare, tone: HIGHLIGHTERS.mint, tilt: 1.2 },
  { text: 'Sort my inbox into notebooks', icon: Inbox, tone: HIGHLIGHTERS.pink, tilt: 1 },
  { text: 'Summarize my latest note', icon: AlignLeft, tone: HIGHLIGHTERS.sky, tilt: -1.2 },
];

/** Sticky-note conversation starters for an empty chat; clicking one asks it. */
export const ChatStarters: React.FC<{ onPick: (text: string) => void; disabled?: boolean }> = ({ onPick, disabled }) => (
  <div className="mt-7 grid w-full max-w-[34rem] grid-cols-2 gap-3 md:gap-4">
    {STARTERS.map((s, i) => (
      <EnterOnce key={s.text} id={`starter:${s.text}`} index={i + 2}>
        <button
          type="button"
          disabled={disabled}
          onClick={() => onPick(s.text)}
          className="pb-squish flex min-h-[84px] w-full cursor-pointer flex-col justify-between gap-2 rounded-lg rounded-br-[1.75rem] border-none p-3.5 text-left shadow-[0_12px_40px_rgba(28,27,25,0.08)] disabled:cursor-default"
          style={{ backgroundColor: s.tone.fill, color: s.tone.ink, '--tilt': `${s.tilt}deg` } as React.CSSProperties}
        >
          <s.icon size={16} />
          <span className="font-body text-[0.8125rem] font-semibold leading-[1.1rem]">{s.text}</span>
        </button>
      </EnterOnce>
    ))}
  </div>
);
